import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    list: {
      title: 'Lista',
      type: 'array',
      items: { type: 'string' }
    }
  },
  allOf: [validationMessages]
};
